import uuidv1 from 'uuid/v1';

export function createNotePayload(note, result = null) { // eslint-disable-line
  let { x, y, content } = note;
  const { id } = note;

  x = Math.round(x);
  y = Math.round(y);
  content = content || '';

  if (result) {
    const res = result;
    res.id = id;
    res.x = x;
    res.y = y;
    res.content = content;
    return res;
  }

  return { id, x, y, content };
}

export function getConfigNotes(config) {
  if (!config) {
    return null;
  }
  const { attributes } = config;
  if (attributes && attributes.notes) {
    return attributes.notes;
  }
  return null;
}

// Returns the number of notes in a config
export function getNumConfigNotes(config) {
  const notes = getConfigNotes(config);
  return notes ? notes.length : 0;
}

// Adds a note to a config
export function addConfigNote(config, note) {
  if (!config) {
    return;
  }
  let notes = getConfigNotes(config);
  if (!notes) {
    const cfg = config;
    notes = [];
    const atts = cfg.attributes || {};
    cfg.attributes = atts;
    atts.notes = notes;
  }

  notes.push(note);
}

// Generates an ID for a new note
export function newConfigNoteID() {
  return `note_${uuidv1()}`;
}

// Creates a new note object
export function newConfigNote(content, x, y) {
  const id = newConfigNoteID();

  return { x, y, content, id };
}

// Sets the location of a config note
export function setConfigNoteLocation(note, x, y) {
  if (!note) {
    return;
  }
  const n = note;
  n.x = Math.round(x);
  n.y = Math.round(y);
}



// WEBPACK FOOTER //
// ./js/utils/project-definition/note-utils.js